import React from 'react';
import {
    Expander,
    ExpanderBorderStyle,
    ExpanderButtonStyle,
    ExpanderTheme,
    ExpanderExpandedHeaderTheme,
} from '@apply/components';

interface MobileDrawBudgetCategoryParameters {
    header: any;
    children: any;
}

export const MobileDrawBudgetCategory: React.FC<MobileDrawBudgetCategoryParameters> = ({ header, children }) => {
    return (
        <Expander
            header={header}
            theme={ExpanderTheme.White}
            buttonStyle={ExpanderButtonStyle.NoRounding}
            borderStyle={ExpanderBorderStyle.NoRounding}
            expandedHeaderTheme={ExpanderExpandedHeaderTheme.Blue}
            initialExpanded={true}
        >
            {children}
        </Expander>
    );
};
